var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { useFormControl } from "../form-control";
import { classNames } from "../../utils/helpers";
import { TextFieldBase } from './TextFieldBase';
import s from './TextField.module.css';
export const TextField = React.forwardRef((_a, ref) => {
    var _b, _c;
    var { className, hasShiftedLabel, inputClassName, inputContainerClassName, labelClassName, truncateLabel } = _a, baseProps = __rest(_a, ["className", "hasShiftedLabel", "inputClassName", "inputContainerClassName", "labelClassName", "truncateLabel"]);
    const [isFocused, setIsFocused] = React.useState(false);
    const [hasEventValue, setHasEventValue] = React.useState(!!baseProps.defaultValue);
    const isLabelShifted = !!baseProps.value || isFocused || hasEventValue || hasShiftedLabel;
    const hasStartElement = !!baseProps.startElement;
    const { hasError: ctxError, disabled: ctxDisabled } = useFormControl();
    const disabled = (_b = baseProps.disabled) !== null && _b !== void 0 ? _b : ctxDisabled;
    const hasError = (_c = baseProps.hasError) !== null && _c !== void 0 ? _c : ctxError;
    const { size = 'large', variant = 'floating' } = baseProps;
    const StartElementContainer = () => baseProps.startElement ? (_jsx("div", { className: s['start-element-container'], children: _jsx("div", { className: s['start-element'], children: baseProps.startElement }) })) : undefined;
    const EndElementContainer = () => baseProps.endElement ? (_jsx("div", { className: s['end-element-container'], children: _jsx("div", { className: s['end-element'], children: baseProps.endElement }) })) : undefined;
    return (_jsx(TextFieldBase, Object.assign({ "data-testid": "st-textfield" }, baseProps, { inputAttributes: Object.assign(Object.assign({}, baseProps.inputAttributes), { onBlur: e => {
                var _a, _b;
                if (baseProps.value === undefined) {
                    setHasEventValue(!!e.target.value);
                }
                setIsFocused(false);
                (_b = (_a = baseProps.inputAttributes) === null || _a === void 0 ? void 0 : _a.onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            }, onFocus: e => {
                var _a, _b;
                setIsFocused(true);
                (_b = (_a = baseProps.inputAttributes) === null || _a === void 0 ? void 0 : _a.onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            } }), onChange: e => {
            var _a;
            const { target: { value: eValue }, } = e;
            if (baseProps.value === undefined) {
                setHasEventValue(!!eValue);
            }
            (_a = baseProps.onChange) === null || _a === void 0 ? void 0 : _a.call(baseProps, e);
        }, className: classNames(s.root, isFocused && s['--focused'], s[`--size-${size}`], disabled && s['--disabled'], hasError && s['--error'], className), inputContainerClassName: classNames(s['input-container'], inputContainerClassName), inputClassName: classNames(s.input, disabled && s['--disabled'], hasError && s['--error'], s[`--size-${size}`], s[`--variant-${variant}`], isLabelShifted && s['--shifted'], hasStartElement && s['--has-start-element'], inputClassName), labelClassName: classNames(s.label, s[`--size-${size}`], s[`--variant-${variant}`], isLabelShifted && s['--shifted'], hasStartElement && s['--has-start-element'], labelClassName), ref: ref, hasShiftedLabel: isLabelShifted, startElement: _jsx(StartElementContainer, {}), endElement: _jsx(EndElementContainer, {}), truncateLabel: truncateLabel })));
});
TextField.displayName = 'TextField';
